export default __webpack_public_path__ + "static/media/DSC_0497.ed6d9167.jpg";